import { ICardDescriptionData } from './types';
import { CARD_DESCRIPTION_DATA_DEFAULT_STATE, CARD_DESCRIPTION_DATA_SESSIONSTORAGE } from './constants';
import { TCardId } from '../../../../../../../../types/types';

export const getCardDescriptionData = (cardId: TCardId): ICardDescriptionData => {
    const _data = sessionStorage.getItem(CARD_DESCRIPTION_DATA_SESSIONSTORAGE);
    const data = _data ? JSON.parse(_data) : CARD_DESCRIPTION_DATA_DEFAULT_STATE;
    return data.cardId === cardId ? data : CARD_DESCRIPTION_DATA_DEFAULT_STATE;
}
